/** CustomerDetails */
export class CustomerDetails {
    /** persona */
public persona: string;
/** process [ Temination | Revokation | LabelOnly ] */
public processType: ProcessTypes;
/** customerType UM or VKD */
public customerType: CustomerTypesEnum;
}
/**  Process Types  */
export enum ProcessTypes {
    Termination = 'Termination',
    Revocation = 'Revocation',
    LabelOnly = 'LabelOnly',
}
/**  Customer Types Enum  */
export enum CustomerTypesEnum {
    UM = 'UM',
    VKD = 'VKD',
    DSL = 'DSL',
}

/**  Download Status  */
export class DownloadStatus  {
    /** QR */
    public qrCode: DownloadMethod;
    /** freightLabel */
    public freightLabel: DownloadMethod;
}

/**  DownloadMethod */
export class DownloadMethod {
    /** email */
    public email: boolean;
    /** direct */
    public direct: boolean;
}
/** customerData */
export class customerData {
    /** type */
    public type: string;
    /** persona */
    public persona: string;
}
